<!-- Professional Partner Program Section -->
<section class="partner-section bg-gradient-primary py-5">
    <div class="container">
        <!-- Hero Section -->
        <div class="row align-items-center mb-5">
            <div class="col-lg-12 text-center">
                <div class="section-badges mb-4">
                    <span class="section-badge"
                        ><i class="bx bx-group"></i> Partnership Program</span
                    >
                </div>
                <h1 class="hero-title mb-4">
                    Grow Your Business with Our
                    <span class="text-highlight">Partner Program</span>
                </h1>
                <p class="hero-description mx-auto mb-4">
                    Join our network of trusted partners and unlock new revenue
                    opportunities while delivering cutting-edge cloud solutions
                    to your customers.
                </p>
                <div class="hero-actions mb-4">
                    <a routerLink="/contact" class="btn-professional-primary">
                        Become a Partner
                    </a>
                    <a href="#how-it-works" class="btn-professional-secondary">
                        Learn More
                    </a>
                </div>
            </div>
        </div>

        <!-- Stats Section -->
        <div class="row mb-5">
            <div class="col-12">
                <div class="stats-container bg-white rounded shadow-sm p-4">
                    <div class="row text-center">
                        <div class="col-md-3 col-6 mb-4 mb-md-0">
                            <div class="stat-item">
                                <div
                                    class="stat-icon bg-primary-light rounded-circle mx-auto mb-3"
                                >
                                    <i class="bx bx-group"></i>
                                </div>
                                <div
                                    class="stat-number display-6 text-primary fw-bold"
                                >
                                    500+
                                </div>
                                <div class="stat-label">Active Partners</div>
                            </div>
                        </div>
                        <div class="col-md-3 col-6 mb-4 mb-md-0">
                            <div class="stat-item">
                                <div
                                    class="stat-icon bg-success-light rounded-circle mx-auto mb-3"
                                >
                                    <i class="bx bx-trending-up"></i>
                                </div>
                                <div
                                    class="stat-number display-6 text-success fw-bold"
                                >
                                    40%
                                </div>
                                <div class="stat-label">
                                    Avg. Revenue Growth
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 col-6">
                            <div class="stat-item">
                                <div
                                    class="stat-icon bg-warning-light rounded-circle mx-auto mb-3"
                                >
                                    <i class="bx bx-award"></i>
                                </div>
                                <div
                                    class="stat-number display-6 text-warning fw-bold"
                                >
                                    15+
                                </div>
                                <div class="stat-label">Partner Benefits</div>
                            </div>
                        </div>
                        <div class="col-md-3 col-6">
                            <div class="stat-item">
                                <div
                                    class="stat-icon bg-info-light rounded-circle mx-auto mb-3"
                                >
                                    <i class="bx bx-support"></i>
                                </div>
                                <div
                                    class="stat-number display-6 text-info fw-bold"
                                >
                                    24/7
                                </div>
                                <div class="stat-label">Dedicated Support</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Why Partner Section -->
        <div class="row mb-5">
            <div class="col-lg-12">
                <div class="section-header text-center mb-5">
                    <h2 class="section-title mb-3">
                        Why Partner <span class="text-gradient">With Us?</span>
                    </h2>
                    <p class="section-description mx-auto">
                        Our comprehensive partner program is designed to help
                        you expand your business reach with our technology,
                        marketing, and sales resources.
                    </p>
                </div>

                <div class="row align-items-center">
                    <div class="col-md-6 mb-4 mb-md-0">
                        <div class="partner-image-container rounded shadow">
                            <img
                                src="assets/img/partner-program.png"
                                alt="Partner Program"
                                class="img-fluid rounded"
                            />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="partner-details">
                            <h3 class="partner-title mb-4">
                                Unlock New Revenue Opportunities
                            </h3>
                            <p class="partner-description mb-4">
                                Our partner program provides you with everything
                                you need to succeed in the cloud market. From
                                technical resources to marketing support, we're
                                committed to your success.
                            </p>

                            <div class="partner-benefits">
                                <h4 class="mb-4">Key Benefits:</h4>
                                <div class="row">
                                    <div class="col-md-6 mb-3">
                                        <div
                                            class="benefit-item d-flex align-items-start"
                                        >
                                            <div
                                                class="benefit-icon bg-primary-light rounded-circle me-3"
                                            >
                                                <i
                                                    class="bx bx-check-circle text-primary"
                                                ></i>
                                            </div>
                                            <div class="benefit-content">
                                                <h5 class="mb-1">
                                                    Revenue Opportunities
                                                </h5>
                                                <p class="mb-0 text-muted">
                                                    Earn commissions through
                                                    referrals
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <div
                                            class="benefit-item d-flex align-items-start"
                                        >
                                            <div
                                                class="benefit-icon bg-primary-light rounded-circle me-3"
                                            >
                                                <i
                                                    class="bx bx-check-circle text-primary"
                                                ></i>
                                            </div>
                                            <div class="benefit-content">
                                                <h5 class="mb-1">
                                                    Technical Resources
                                                </h5>
                                                <p class="mb-0 text-muted">
                                                    Access to training and
                                                    support
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <div
                                            class="benefit-item d-flex align-items-start"
                                        >
                                            <div
                                                class="benefit-icon bg-primary-light rounded-circle me-3"
                                            >
                                                <i
                                                    class="bx bx-check-circle text-primary"
                                                ></i>
                                            </div>
                                            <div class="benefit-content">
                                                <h5 class="mb-1">
                                                    Marketing Tools
                                                </h5>
                                                <p class="mb-0 text-muted">
                                                    Sales enablement resources
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <div
                                            class="benefit-item d-flex align-items-start"
                                        >
                                            <div
                                                class="benefit-icon bg-primary-light rounded-circle me-3"
                                            >
                                                <i
                                                    class="bx bx-check-circle text-primary"
                                                ></i>
                                            </div>
                                            <div class="benefit-content">
                                                <h5 class="mb-1">
                                                    Co-Marketing
                                                </h5>
                                                <p class="mb-0 text-muted">
                                                    Joint promotional
                                                    opportunities
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Partner Types Section -->
        <div class="partner-types-section mb-5" id="partner-types">
            <div class="section-header text-center mb-5">
                <h2 class="section-title mb-3">
                    Partner <span class="text-gradient">Types</span>
                </h2>
                <p class="section-description mx-auto">
                    Choose the partnership model that best fits your business
                    needs and customer base.
                </p>
            </div>
            <div class="row">
                <div class="col-md-4 mb-4">
                    <div
                        class="partner-type-card card h-100 shadow-sm border-0"
                    >
                        <div class="card-body text-center p-4">
                            <div
                                class="partner-icon bg-primary-light rounded-circle mx-auto mb-4"
                            >
                                <i class="bx bx-briefcase-alt text-primary"></i>
                            </div>
                            <h4 class="card-title mb-3">Technology Partners</h4>
                            <p class="card-text mb-4">
                                Integrate your solutions with our platform to
                                offer enhanced services to customers. Get access
                                to our APIs and development resources.
                            </p>
                            <ul class="text-start list-unstyled mb-4">
                                <li class="mb-2">
                                    <i
                                        class="bx bx-check-circle text-success me-2"
                                    ></i>
                                    API Access
                                </li>
                                <li class="mb-2">
                                    <i
                                        class="bx bx-check-circle text-success me-2"
                                    ></i>
                                    Technical Support
                                </li>
                                <li class="mb-2">
                                    <i
                                        class="bx bx-check-circle text-success me-2"
                                    ></i>
                                    Joint Development
                                </li>
                            </ul>
                            <a href="#" class="btn btn-outline-primary"
                                >Learn More</a
                            >
                        </div>
                    </div>
                </div>

                <div class="col-md-4 mb-4">
                    <div
                        class="partner-type-card card h-100 shadow-sm border-0"
                    >
                        <div class="card-body text-center p-4">
                            <div
                                class="partner-icon bg-success-light rounded-circle mx-auto mb-4"
                            >
                                <i class="bx bx-line-chart text-success"></i>
                            </div>
                            <h4 class="card-title mb-3">Reseller Partners</h4>
                            <p class="card-text mb-4">
                                Sell our cloud services to your customers and
                                earn commissions on transactions. Get
                                competitive pricing and margins.
                            </p>
                            <ul class="text-start list-unstyled mb-4">
                                <li class="mb-2">
                                    <i
                                        class="bx bx-check-circle text-success me-2"
                                    ></i>
                                    Competitive Pricing
                                </li>
                                <li class="mb-2">
                                    <i
                                        class="bx bx-check-circle text-success me-2"
                                    ></i>
                                    Sales Training
                                </li>
                                <li class="mb-2">
                                    <i
                                        class="bx bx-check-circle text-success me-2"
                                    ></i>
                                    Marketing Materials
                                </li>
                            </ul>
                            <a href="#" class="btn btn-outline-success"
                                >Learn More</a
                            >
                        </div>
                    </div>
                </div>

                <div class="col-md-4 mb-4">
                    <div
                        class="partner-type-card card h-100 shadow-sm border-0"
                    >
                        <div class="card-body text-center p-4">
                            <div
                                class="partner-icon bg-warning-light rounded-circle mx-auto mb-4"
                            >
                                <i class="bx bx-group text-warning"></i>
                            </div>
                            <h4 class="card-title mb-3">Referral Partners</h4>
                            <p class="card-text mb-4">
                                Refer customers to us and earn rewards for
                                successful conversions. Perfect for consultants
                                and advisors.
                            </p>
                            <ul class="text-start list-unstyled mb-4">
                                <li class="mb-2">
                                    <i
                                        class="bx bx-check-circle text-success me-2"
                                    ></i>
                                    Referral Rewards
                                </li>
                                <li class="mb-2">
                                    <i
                                        class="bx bx-check-circle text-success me-2"
                                    ></i>
                                    Easy Tracking
                                </li>
                                <li class="mb-2">
                                    <i
                                        class="bx bx-check-circle text-success me-2"
                                    ></i>
                                    Quick Payouts
                                </li>
                            </ul>
                            <a href="#" class="btn btn-outline-warning"
                                >Learn More</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- How It Works Section -->
        <div class="partner-process-section mb-5" id="how-it-works">
            <div class="section-header text-center mb-5">
                <h2 class="section-title mb-3">
                    How It <span class="text-gradient">Works</span>
                </h2>
                <p class="section-description mx-auto">
                    Joining our partner program is simple and straightforward.
                    Get started in just four easy steps.
                </p>
            </div>
            <div class="row">
                <div class="col-md-3 mb-4">
                    <div
                        class="process-step text-center card h-100 shadow-sm border-0 p-4"
                    >
                        <div
                            class="process-icon bg-primary text-white rounded-circle mx-auto mb-4"
                        >
                            <h4 class="mb-0">1</h4>
                        </div>
                        <h5 class="mb-3">Register</h5>
                        <p class="text-muted">
                            Sign up for our partner program by filling out a
                            simple application form.
                        </p>
                    </div>
                </div>

                <div class="col-md-3 mb-4">
                    <div
                        class="process-step text-center card h-100 shadow-sm border-0 p-4"
                    >
                        <div
                            class="process-icon bg-primary text-white rounded-circle mx-auto mb-4"
                        >
                            <h4 class="mb-0">2</h4>
                        </div>
                        <h5 class="mb-3">Get Access</h5>
                        <p class="text-muted">
                            Receive partner resources, training materials, and
                            account setup.
                        </p>
                    </div>
                </div>

                <div class="col-md-3 mb-4">
                    <div
                        class="process-step text-center card h-100 shadow-sm border-0 p-4"
                    >
                        <div
                            class="process-icon bg-primary text-white rounded-circle mx-auto mb-4"
                        >
                            <h4 class="mb-0">3</h4>
                        </div>
                        <h5 class="mb-3">Promote</h5>
                        <p class="text-muted">
                            Market our solutions to your network using our
                            marketing resources.
                        </p>
                    </div>
                </div>

                <div class="col-md-3 mb-4">
                    <div
                        class="process-step text-center card h-100 shadow-sm border-0 p-4"
                    >
                        <div
                            class="process-icon bg-primary text-white rounded-circle mx-auto mb-4"
                        >
                            <h4 class="mb-0">4</h4>
                        </div>
                        <h5 class="mb-3">Earn</h5>
                        <p class="text-muted">
                            Receive commissions and rewards for successful
                            customer referrals.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <!-- CTA Section -->
        <div class="row mb-5">
            <div class="col-lg-12">
                <div
                    class="cta-section bg-gradient-primary rounded shadow text-center p-5"
                >
                    <h2 class="text-white mb-3">Ready to Become a Partner?</h2>
                    <p class="text-white mb-4">
                        Join our growing network of partners and start earning
                        today.
                    </p>
                    <div class="cta-actions">
                        <a
                            routerLink="/contact"
                            class="btn btn-light btn-lg me-3"
                            >Join Our Partner Program</a
                        >
                        <a
                            href="tel:+919167663638"
                            class="btn btn-outline-light btn-lg"
                        >
                            <i class="bx bx-phone"></i> Call Us
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
